<template>
  <vue-highcharts type="chart" :options="options" class="custom-zone-time" />
</template>
<script>
import { mapGetters } from 'vuex'
import VueHighcharts from 'vue3-highcharts'
export default {
  name: 'progress-zones',
  components: {
    VueHighcharts,
  },
  props: {
    isReport: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('usercardio', ['memberGoals']),
    goals() {
      let _data = {
        cardioProgram: null,
        weekProgress: null,
      }
      if (this.memberGoals) {
        _data = this.memberGoals
      }
      return _data
    },
    totalMinutes() {
      let _data = 0
      if (this.goals.cardioProgram) {
        _data = parseFloat(this.goals.cardioProgram[0].TotalMinutes)
      }
      return _data
    },
    totalTimeWeek() {
      let _data = 0
      if (this.goals.weekProgress) {
        if (this.goals.weekProgress.length > 0) {
          _data = (
            parseFloat(this.goals.weekProgress[0].InZoneTime) / 60 +
            parseFloat(this.goals.weekProgress[0].AboveZoneTime) / 60
          ).toFixed(0)
        }
      }
      return _data
    },
    zoneTimeWeek() {
      let _data = [
        {
          name: 'Below Zone',
          y: this.goals.weekProgress
            ? this.goals.weekProgress.length > 0
              ? parseFloat(this.goals.weekProgress[0].BelowZoneTime) / 60
              : 0
            : 0,
          color: '#959595',
        },
        {
          name: 'In Zone',
          y: this.goals.weekProgress
            ? this.goals.weekProgress.length > 0
              ? parseFloat(this.goals.weekProgress[0].InZoneTime) / 60
              : 0
            : 0,
          color: '#224C7C',
        },
        {
          name: 'Above Zone',
          y: this.goals.weekProgress
            ? this.goals.weekProgress.length > 0
              ? parseFloat(this.goals.weekProgress[0].AboveZoneTime) / 60
              : 0
            : 0,
          color: '#E77F26',
        },
      ]
      return _data
    },
    options() {
      var goal = this.totalMinutes
      var percent =
        goal !== 0 ? ((this.totalTimeWeek / goal) * 100).toFixed(1) : 0
      var doAnimation = true
      if (this.isReport !== undefined && this.isReport !== null) {
        if (this.isReport === '1') doAnimation = false
      }
      let _options = {
        chart: {
          type: 'pie',
          spacing: [0, 0, 0, 0],
          animation: doAnimation,
          width: 250,
          height: 250,
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        title: {
          text: this.totalTimeWeek.toString(),
          align: 'center',
          verticalAlign: 'center',
          x: 0,
          y: 115,
          style: {
            'font-size': '36px',
            'font-weight': '600',
            color: '#959595',
          },
        },
        subtitle: {
          text:
            this.totalTimeWeek !== 0
              ? `<div style="text-align: center;"><span>ACTIVE MINUTES</span><br/><span style="margin-top:10px;">${percent}%</span></div>`
              : '',
          useHTML: true,
          align: 'center',
          verticalAlign: 'center',
          x: 0,
          y: 145,
          style: {
            'font-size': '14px',
            'font-weight': '600',
            color: '#959595',
          },
        },
        plotOptions: {
          pie: {
            shadow: false,
            center: ['50%', '50%'],
          },
        },
        tooltip: {
          formatter: function () {
            let result = `${this.point.name}: ${this.point.y.toFixed(0)} mins`
            return result
          },
        },
        series: [
          {
            name: 'Time',
            data: this.zoneTimeWeek,
            size: '80%',
            innerSize: '65%',
            dataLabels: {
              enabled: false,
            },
            animation: doAnimation,
          },
        ],
      }
      return _options
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-zone-time {
  width: 250px;
  height: 250px;
  margin: 0 auto;
}
</style>
